export default "__VITE_ASSET__EDZ2_oml__"